import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ScoutBannerWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 150px;
  margin-bottom: ${Spacing.S16};
`

export const ScoutBannerContentWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  height: 92px;
  padding: ${Spacing.S16};
  border-radius: ${Spacing.S12};
  background-color: ${Color.Lavender100};
`
